import React from 'react';
import ServicePageTemplate from './ServicePageTemplate';
import { softwareDevelopmentConfig } from './servicePageConfigs';

const SoftwareDevelopment = () => <ServicePageTemplate {...softwareDevelopmentConfig} />;

export default SoftwareDevelopment;
